import api from '~/api'
import get from 'lodash/get'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  async getOrder(_, id) {
    const [error, response] = await api.post('/search/orders/_search', {
      query: { match_phrase: { id } },
    })

    return [error, get(response, 'hits.hits[0]._source', null)]
  },
  async getOrderItem(_, id) {
    const [error, response] = await api.post('/search/order-items/_search', {
      query: { match_phrase: { id } },
    })

    return [error, get(response, 'hits.hits[0]._source', null)]
  },
  updateOrderItem(_, { id, orderId, form }) {
    return api.patch(`orders/${orderId}/items/${id}`, form)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
